module.exports = __webpack_public_path__ + "img/svg/background-stars.6da6d1cae5eeb555854f708028ab46c9.svg";